// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VListItemSubtitle = createSimpleFunctional('v-list-item-subtitle');
//# sourceMappingURL=VListItemSubtitle.mjs.map